import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { changeConfigDataValue, changeFlexibleSpecValue } from 'redux/modules/audience';
import { categorySearch, getTargetingInfo, queryMajor, querySchool, queryEmployer, queryJobTitles } from 'redux/modules/audienceDemographics';
import { Spinner } from 'components';
import * as _ from 'lodash';
import AutoComplete from 'material-ui/AutoComplete';
import MenuItem from 'material-ui/MenuItem';
import Chip from 'material-ui/Chip';
import SelectField from 'material-ui/SelectField';
import * as styles from './AdBuilder.scss';
var AudienceDemographics = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    exclusions: state.audience.FacebookTargetingConfig.data.exclusions,
    adAccount: state.ads.adAccount && state.ads.adAccount[orgId] ? state.ads.adAccount[orgId] : null,
    loadingCategory: state.audienceDemographics.loadingCategory,
    organization: state.organization.current
  };
}, {
  categorySearch: categorySearch,
  changeConfigDataValue: changeConfigDataValue,
  changeFlexibleSpecValue: changeFlexibleSpecValue,
  getTargetingInfo: getTargetingInfo,
  queryJobTitles: queryJobTitles,
  queryMajor: queryMajor,
  querySchool: querySchool,
  queryEmployer: queryEmployer
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(AudienceDemographics, _Component);

  var _super = _createSuper(AudienceDemographics);

  function AudienceDemographics(props) {
    var _this;

    _classCallCheck(this, AudienceDemographics);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleCategoryChange", function (e, i, val) {
      var showJobTitle = val === 'job_title';
      var showSchool = val === 'school';
      var showMajor = val === 'major';
      var showEmployer = val === 'employer';

      _this.setState({
        selectedCategory: val,
        showJobTitleAutoComplete: showJobTitle,
        showMajorAutoComplete: showMajor,
        showEmployerAutoComplete: showEmployer,
        showSchoolAutoComplete: showSchool
      });

      if (val === 'job_title' || val === 'school' || val === 'major' || val === 'employer') {
        return;
      }

      if (val === 'relationship_statuses' || val === 'education_statuses') {
        if (val === 'education_statuses') {
          _this.setState({
            category: val,
            dataSource: _this.state.educationOptions
          });
        }

        if (val === 'relationship_statuses') {
          _this.setState({
            dataSource: _this.state.relationshipOptions
          });
        }
      } else {
        _this.props.categorySearch(val).then(function (res) {
          _this.setState({
            dataSource: res.data
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleExclusionValueSelected", function (value) {
      console.log('handleExclusionValueSelected');
      console.log(value);
      var updatedExclusions = Object.assign({}, _this.props.exclusions);

      if (value.type === 'relationship_statuses' || value.type === 'education_statuses') {
        updatedExclusions[value.type] = _.union(updatedExclusions[value.type], [parseInt(value.id)]);
      } else {
        var strippedNewValue = {
          id: value.id,
          name: value.name
        }; //    updatedExclusions.interests = _.unionBy(updatedExclusions.interests, [strippedNewValue], 'id');

        updatedExclusions[value.type] = [].concat(_toConsumableArray(updatedExclusions[value.type]), [strippedNewValue]);
      }

      _this.props.changeConfigDataValue('exclusions', updatedExclusions);
    });

    _defineProperty(_assertThisInitialized(_this), "handleValueSelected", function (v, key) {
      var item = _this.state.dataSource[key];
      _this.props.isExclusion ? _this.handleExclusionValueSelected(item) : _this.props.changeFlexibleSpecValue(_this.props.specIndex, item);
    });

    _defineProperty(_assertThisInitialized(_this), "handleAutoCompleteSelected", function (v, category) {
      var type = '';

      switch (category) {
        case 'school':
          type = 'education_schools';
          break;

        case 'job_title':
          type = 'work_positions';
          break;

        case 'major':
          type = 'education_majors';
          break;

        case 'employer':
          type = 'work_employers';
          break;
      }

      v.type = type;
      _this.props.isExclusion ? _this.handleExclusionValueSelected(v) : _this.props.changeFlexibleSpecValue(_this.props.specIndex, v);
    });

    _defineProperty(_assertThisInitialized(_this), "queryMajor", _.debounce(function (query) {
      if (query) {
        _this.props.queryMajor(query).then(function (res) {
          _this.setState({
            majorDataSource: res.data
          });
        });
      }
    }, 200));

    _defineProperty(_assertThisInitialized(_this), "querySchool", _.debounce(function (query) {
      if (query) {
        _this.props.querySchool(query).then(function (res) {
          _this.setState({
            schoolDataSource: res.data
          });
        });
      }
    }, 200));

    _defineProperty(_assertThisInitialized(_this), "queryEmployer", _.debounce(function (query) {
      if (query) {
        _this.props.queryEmployer(query).then(function (res) {
          _this.setState({
            employerDataSource: res.data
          });
        });
      }
    }, 200));

    _defineProperty(_assertThisInitialized(_this), "queryJobTitles", _.debounce(function (query) {
      if (query) {
        _this.props.queryJobTitles(query).then(function (res) {
          _this.setState({
            jobTitlesDataSource: res.data
          });
        });
      }
    }, 200));

    _defineProperty(_assertThisInitialized(_this), "renderSearchArea", function () {
      var demographicSelectOptions = _this.state.dataSource.map(function (d, index) {
        return /*#__PURE__*/React.createElement(MenuItem, {
          value: index,
          key: index,
          primaryText: d.name
        });
      });

      if (_this.state.showJobTitleAutoComplete) {
        return /*#__PURE__*/React.createElement(AutoComplete, {
          filter: AutoComplete.fuzzyFilter,
          openOnFocus: true,
          searchText: _this.state.jobTitleAutoCompleteText,
          hintText: "Search job titles",
          dataSource: _this.state.jobTitlesDataSource,
          dataSourceConfig: {
            text: 'name',
            value: 'id'
          },
          onUpdateInput: function onUpdateInput(searchText) {
            _this.setState({
              jobTitleAutoCompleteText: searchText
            });

            _this.queryJobTitles(searchText);
          },
          onNewRequest: function onNewRequest(value, index) {
            return _this.handleAutoCompleteSelected(value, 'job_title');
          }
        });
      } else if (_this.state.showMajorAutoComplete) {
        return /*#__PURE__*/React.createElement(AutoComplete, {
          filter: AutoComplete.fuzzyFilter,
          openOnFocus: true,
          searchText: _this.state.majorAutoCompleteText,
          hintText: "Search majors",
          dataSource: _this.state.majorDataSource,
          dataSourceConfig: {
            text: 'name',
            value: 'id'
          },
          onUpdateInput: function onUpdateInput(searchText) {
            _this.setState({
              majorAutoCompleteText: searchText
            });

            _this.queryMajor(searchText);
          },
          onNewRequest: function onNewRequest(value, index) {
            return _this.handleAutoCompleteSelected(value, 'major');
          }
        });
      } else if (_this.state.showSchoolAutoComplete) {
        return /*#__PURE__*/React.createElement(AutoComplete, {
          filter: AutoComplete.fuzzyFilter,
          openOnFocus: true,
          searchText: _this.state.schoolAutoCompleteText,
          hintText: "Search schools",
          dataSource: _this.state.schoolDataSource,
          dataSourceConfig: {
            text: 'name',
            value: 'id'
          },
          onUpdateInput: function onUpdateInput(searchText) {
            _this.setState({
              schoolAutoCompleteText: searchText
            });

            _this.querySchool(searchText);
          },
          onNewRequest: function onNewRequest(value, index) {
            console.log('onNewRequest of school');

            _this.handleAutoCompleteSelected(value, 'school');
          }
        });
      } else if (_this.state.showEmployerAutoComplete) {
        return /*#__PURE__*/React.createElement(AutoComplete, {
          filter: AutoComplete.fuzzyFilter,
          openOnFocus: true,
          searchText: _this.state.employerAutoCompleteText,
          hintText: "Search employers",
          dataSource: _this.state.employerDataSource,
          dataSourceConfig: {
            text: 'name',
            value: 'id'
          },
          onUpdateInput: function onUpdateInput(searchText) {
            _this.setState({
              employerAutoCompleteText: searchText
            });

            _this.queryEmployer(searchText);
          },
          onNewRequest: function onNewRequest(value, index) {
            return _this.handleAutoCompleteSelected(value, 'employer');
          }
        });
      }

      return /*#__PURE__*/React.createElement("div", null, _this.props.loadingCategory ? /*#__PURE__*/React.createElement(Spinner, {
        center: true,
        style: {
          top: 0
        }
      }) : /*#__PURE__*/React.createElement(SelectField, {
        style: {
          verticalAlign: 'top'
        },
        fullWidth: true,
        onChange: _this.handleValueSelected
      }, demographicSelectOptions));
    });

    _this.state = {
      showMajorAutoComplete: false,
      showEmployerAutoComplete: false,
      showSchoolAutoComplete: false,
      showJobTitleAutoComplete: false,
      jobTitleAutoCompleteText: '',
      schoolAutoCompleteText: '',
      majorAutoCompleteText: '',
      employerAutoCompleteText: '',
      selectedType: 1,
      selectedCategory: '',
      majorDataSource: [],
      schoolDataSource: [],
      employerDataSource: [],
      jobTitlesDataSource: [],
      dataSource: [],
      categoryNames: [{
        name: 'school',
        displayName: 'Schools'
      }, {
        name: 'major',
        displayName: 'Fields Of Study'
      }, {
        name: 'education_statuses',
        displayName: 'Education Level'
      }, {
        name: 'employer',
        displayName: 'Employer'
      }, {
        name: 'job_title',
        displayName: 'Job Title'
      }, {
        name: 'industries',
        displayName: 'Industries'
      }, {
        name: 'life_events',
        displayName: 'Life Events'
      }, {
        name: 'family_statuses',
        displayName: 'Parents'
      }, {
        name: 'relationship_statuses',
        displayName: 'Relationship'
      }],
      educationOptions: [{
        id: '6',
        name: 'Associate degree',
        type: 'education_statuses'
      }, {
        id: '3',
        name: 'College grad',
        type: 'education_statuses'
      }, {
        id: '11',
        name: 'Doctorate degree',
        type: 'education_statuses'
      }, {
        id: '4',
        name: 'High school grad',
        type: 'education_statuses'
      }, {
        id: '2',
        name: 'In college',
        type: 'education_statuses'
      }, {
        id: '7',
        name: 'In grad school',
        type: 'education_statuses'
      }, {
        id: '1',
        name: 'In high school',
        type: 'education_statuses'
      }, {
        id: '9',
        name: "Master's degree",
        type: 'education_statuses'
      }, {
        id: '10',
        name: 'Professional degree',
        type: 'education_statuses'
      }, {
        id: '5',
        name: 'Some college',
        type: 'education_statuses'
      }, {
        id: '8',
        name: 'Some grad school',
        type: 'education_statuses'
      }, {
        id: '13',
        name: 'Some high school',
        type: 'education_statuses'
      }, {
        id: '12',
        name: 'Unspecified',
        type: 'education_statuses'
      }],
      relationshipOptions: [{
        id: '7',
        name: 'Civil Union',
        type: 'relationship_statuses'
      }, {
        id: '10',
        name: 'Complicated',
        type: 'relationship_statuses'
      }, {
        id: '12',
        name: 'Divorced',
        type: 'relationship_statuses'
      }, {
        id: '8',
        name: 'Domestic Partnership'
      }, {
        id: '4',
        name: 'Engaged',
        type: 'relationship_statuses'
      }, {
        id: '2',
        name: 'In a relationship',
        type: 'relationship_statuses'
      }, {
        id: '3',
        name: 'Married',
        type: 'relationship_statuses'
      }, {
        id: '9',
        name: 'Open Relationship',
        type: 'relationship_statuses'
      }, {
        id: '11',
        name: 'Separated',
        type: 'relationship_statuses'
      }, {
        id: '1',
        name: 'Single',
        type: 'relationship_statuses'
      }, {
        id: '6',
        name: 'Unspecified',
        type: 'relationship_statuses'
      }, {
        id: '13',
        name: 'Widowed',
        type: 'relationship_statuses'
      }]
    };
    return _this;
  }
  /** *********************************************************
   EVENT HANDLERS
   ***********************************************************/


  _createClass(AudienceDemographics, [{
    key: "render",
    value: function render() {
      var demographicCategories = this.state.categoryNames.map(function (d, index) {
        return /*#__PURE__*/React.createElement(MenuItem, {
          value: d.name,
          key: index,
          primaryText: d.displayName
        });
      });
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-3",
        style: {
          lineHeight: '48px',
          color: '#616161'
        }
      }, "Demographics"), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-3"
      }, /*#__PURE__*/React.createElement(SelectField, {
        style: {
          verticalAlign: 'top'
        },
        fullWidth: true,
        onChange: this.handleCategoryChange,
        value: this.state.selectedCategory
      }, demographicCategories)), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-6",
        style: {
          position: 'relative'
        }
      }, this.renderSearchArea())));
    }
  }]);

  return AudienceDemographics;
}(Component)) || _class);
export { AudienceDemographics as default };
AudienceDemographics.defaultProps = {
  specIndex: 0
};